import React, { Component } from "react";

export default class MobileUserDashboard extends Component {
  render() {
    return (
      <div>
        To access this functionality please use calbit customers mobile app
        accessible from app/play stores or from the download link below.
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/customers/mobileusers_dashboard.js